import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** padlock. Decorative line icon; always pair with a visible text label. */
export function LockIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <rect x="5" y="10.5" width="14" height="9.5" rx="2" />
      <path d="M8.5 10.5V7.5a3.5 3.5 0 0 1 7 0v3" />
      <path d="M12 14.5v2" />
    </IconSvg>
  )
}
